import { useState } from 'react';
import clsx from 'clsx';

import { Box } from '../../Box/Box';
import { IconSolidCheveronDown, IconSolidCheveronUp } from '../../icons';
import { Text } from '../../Text/Text';

import { collapsed, collapsibleContainer, collapsibleHeader } from './styles.css';

export type Props = {
  title: string;
  children: React.ReactNode;
};

export const Collapsible: React.FC<Props> = ({ children, title }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box display="flex" flexDirection="column" cssClass={collapsibleContainer} height="full">
      <Box
        cssClass={clsx(collapsibleHeader, {
          [collapsed]: !expanded,
        })}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        onClick={() => setExpanded(!expanded)}
        py="12"
        px="8"
        cursor="pointer"
      >
        <Text>{title}</Text>
        {expanded ? <IconSolidCheveronUp size={16} /> : <IconSolidCheveronDown size={16} />}
      </Box>
      {expanded && children}
    </Box>
  );
};
